export default [{
    value: 'Coverholder_Name',
    text: 'Coverholder Name',
    sortable: true,
    width: 170,
    default: true,
    disabled: true
  },
  {
    value: 'TPA_Name',
    text: 'TPA Name',
    sortable: true,
    width: 170,
    default: true,
    disabled: true
  },
  {
    value: 'TPA_Group_Name',
    text: 'TPA Group Name',
    default: false,
    custom: true
  },
  {
    // CV-12 (LIQ-2577): the program's lead underwriter(s), filled by Lincoln. Every role may
    // pick it; unticked unless chosen.
    value: 'Lead_Underwriter',
    text: 'Lead Underwriter',
    default: false,
    custom: true
  },
  {
    value: 'Agreement',
    text: 'Agreement No',
    default: true
  },
  {
    value: 'Unique_Market_Reference_UMR',
    text: 'Unique Market Reference (UMR)',
    sortable: true,
    width: 120,
    default: true,
    disabled: true
  },
  {
    value: 'Binder_Contract_Inception',
    text: 'Binding Authority Or Coverholder Appointment Agreement Inception Date',
    default: true,
    isDate: true
  },
  {
    value: 'Binder_Contract_Expiry',
    text: 'Binding Authority Or Coverholder Appointment Agreement Expiry Date',
    default: true,
    isDate: true
  },
  {
    value: 'Reporting_Period_End_Date',
    text: 'Reporting Period (End Date)',
    sortable: true,
    width: 200,
    default: true,
    isDate: true,
    disabled: true

  },
  {
    value: 'Class_of_Business',
    text: 'Class of Business',
    default: true
  },
  {
    value: 'Risk_Code',
    text: "Lloyd's Risk Code",
    default: true,
    disabled: true
  },
  {
    value: 'Section_No',
    text: 'Section No',
    default: true,
    disabled: true
  },
  {
    value: 'Original_Currency',
    text: 'Original Currency',
    default: true
  },
  {
    value: 'Settlement_Currency',
    text: 'Settlement Currency',
    default: true,
    disabled: true
  },
  {
    value: 'Rate_of_Exchange',
    text: 'Rate Of Exchange',
    default: true,
    decimals: 2
  },
  {
    value: 'Certificate_Reference',
    text: 'Certificate Reference',
    default: true
  },
  {
    value: 'Claim_Reference',
    text: 'Claim Reference / Number',
    default: true,
    disabled: true
  },
  {
    value: 'Previous_Claim_Ref',
    text: 'Previous Claim Ref',
    default: true,
    custom: true
  },
  {
    value: 'Insured_Full_Name',
    text: 'Insured Full Name Or Company Name',
    default: true
  },
  {
    value: 'Insured_State',
    text: 'Insured State, Province, Territory, Canton etc.',
    default: true
  },
  {
    value: 'Insured_Country',
    text: 'Insured Country',
    default: true
  },
  {
    value: 'Location_of_Risk_State',
    text: 'Location Of Risk State, Province, Territory, Canton',
    default: true
  },
  {
    value: 'Location_of_Risk_County',
    text: 'Location of Risk County',
    default: true
  },
  {
    value: 'Risk_Inception_Date',
    text: 'Risk Inception Date',
    default: true,
    isDate: true
  },
  {
    value: 'Risk_Expiry_Date',
    text: 'Risk Expiry Date',
    default: true,
    isDate: true
  },
  {
    value: 'Period_of_Cover',
    text: 'Period of Cover - Narrative',
    default: true
  },
  {
    value: 'Loss_State',
    text: 'Location Of Loss State, Province, Territory, Canton',
    default: true
  },
  {
    value: 'Location_of_Loss_Country',
    text: 'Location of Loss Country',
    default: true
  },
  {
    value: 'Cause_of_Loss',
    text: 'Cause of Loss Code',
    default: true
  },
  {
    value: 'Loss_Description',
    text: 'Loss Description',
    default: true
  },
  {
    value: 'Loss_Type',
    text: 'Loss Type',
    default: true,
    custom: true
  },
  {
    value: 'Date_of_Loss_From',
    text: 'Date of Loss (From)',
    default: true,
    isDate: true
  },
  {
    value: 'Date_of_Loss_To',
    text: 'Date of Loss (To)',
    default: true,
    isDate: true
  },
  {
    value: 'Date_Claim_Made',
    text: 'Date Claim First Advised/Date Claim Made',
    default: true,
    isDate: true
  },
  {
    value: 'Claim_Status',
    text: 'Claim Status',
    default: true
  },
  {
    value: 'Refer_to_Underwriters',
    text: 'Refer to Underwriters',
    default: true
  },
  {
    value: 'Denial',
    text: 'Denial',
    default: true
  },
  {
    value: 'Claimant_Name',
    text: 'Claimant Name',
    default: true
  },
  {
    value: 'Loss_County',
    text: 'Loss County',
    default: true,
    region: ["US", "Canada"]
  },
  {
    value: 'State_of_Filing',
    text: 'State of Filing',
    default: true,
    region: ["US"]
  },
  {
    value: 'PCS_Code',
    text: 'PCS Code',
    default: true,
    region: ["US", "Canada"]
  },
  {
    value: 'Medicare_United_States_Bodily_Injury',
    text: 'Medicare United States Bodily Injury',
    default: true,
    region: ["US"]
  },
  {
    value: 'Medicare_Eligibility_Check_Performed',
    text: 'Medicare Eligibility Check Performance',
    default: true,
    region: ["US"]
  },
  {
    value: 'Medicare_Outcome_of_Eligibility_Status_Check',
    text: 'Medicare Outcome of Eligibility Status Check',
    default: true,
    region: ["US"]
  },
  {
    value: 'Medicare_Conditional_Payments',
    text: 'Medicare Conditional Payments',
    default: true,
    region: ["US"]
  },
  {
    value: 'Medicare_MSP_Compliance_Services',
    text: 'Medicare MSP Compliance Services',
    default: true,
    region: ["US"]
  },
  {
    value: 'Paid_This_Month_Indemnity',
    text: 'Paid This Month - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_This_Month_Indemnity_Buildings',
    text: 'Paid this month - Indemnity Buildings',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Paid_This_Month_Indemnity_Contents',
    text: 'Paid this month - Indemnity Contents',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Paid_This_Month_Fees',
    text: 'Paid This Month - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Indemnity',
    text: 'Previously Paid - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Indemnity_Buildings',
    text: 'Previously Paid - Indemnity Buildings',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Previously_Paid_Indemnity_Contents',
    text: 'Previously Paid - Indemnity Contents',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Previously_Paid_Fees',
    text: 'Previously Paid - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Indemnity',
    text: 'Reserve - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Indemnity_Buildings',
    text: 'Reserve - Indemnity Buildings',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Reserve_Indemnity_Contents',
    text: 'Reserve - Indemnity Contents',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Reserve_Fees',
    text: 'Reserve - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Change_This_Month_Indemnity',
    text: 'Change This Month - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Change_This_Month_Fees',
    text: 'Change This Month - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Total_Incurred_Indemnity',
    text: 'Total Incurred - Indemnity',
    default: true,
    decimals: 2
  },
  {
    value: 'Total_Incurred_Indemnity_Buildings',
    text: 'Total Incurred - Indemnity Buildings',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Total_Incurred_Indemnity_Contents',
    text: 'Total Incurred - Indemnity Contents',
    default: true,
    decimals: 2,
    custom: true
  },
  {
    value: 'Total_Incurred_Fees',
    text: 'Total Incurred - Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Coverholder_PIN',
    text: 'Coverholder PIN',
    default: true
  },
  {
    value: 'Reporting_Period_Start_Date',
    text: 'Reporting Period Start Date',
    default: true
  },
  {
    value: 'Type_of_Insurance',
    text: 'Type of Insurance (Direct, or Type of RI)',
    default: true
  },
  {
    value: 'Policy_or_Group_Ref',
    text: 'Policy or Group Ref',
    default: true
  },
  {
    value: 'Insured_Address',
    text: 'Insured Address',
    default: true
  },
  {
    value: 'Insured_Postcode_Zip_Code_or_similar',
    text: 'Insured Postcode Zip Code Or Similar',
    default: true
  },
  {
    value: 'Location_of_Risk_Location_ID',
    text: 'Location Of Risk Location ID',
    default: true
  },
  {
    value: 'Location_of_Risk_Address',
    text: 'Location Of Risk Address',
    default: true
  },
  {
    value: 'Location_of_Risk_Postcode_Zip_Code_or_similar',
    text: 'Location Of Risk Postcode Zip Code Or Similar',
    default: true
  },
  {
    value: 'Deductible_Amount',
    text: 'Deductible Amount',
    default: true,
    decimals: 2
  },
  {
    value: 'Deductible_Basis',
    text: 'Deductible Basis',
    default: true
  },
  {
    value: 'Sums_Insured_Amount',
    text: 'Sums Insured Amount',
    default: true,
    decimals: 2
  },
  {
    value: 'Location_of_Loss_Address',
    text: 'Location of Loss Address',
    default: true
  },
  {
    value: 'Location_of_Loss_Postcode_Zip_Code_or_similar',
    text: 'Location Of Loss Postcode Zip Code Or Similar',
    default: true
  },
  {
    value: 'Date_Closed',
    text: 'Date Closed',
    default: true,
    isDate: true
  },
  {
    value: 'Lloyds_Cat_Code',
    text: "Lloyd's Cat Code",
    default: true,
    disabled: true
  },
  {
    value: 'Catastrophe_Name',
    text: 'Catastrophe Name',
    default: true
  },
  {
    value: 'Paid_this_month_Expenses',
    text: 'Paid This Month - Expenses',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_Attorney_Coverage_Fees',
    text: 'Paid This Month - Attorney Coverage Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_Adjusters_Fees',
    text: 'Paid This Month - Adjusters Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_Defence_Fees',
    text: 'Paid This Month - Defence Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_TPA_Fees',
    text: 'Paid This Month - TPA Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Paid_this_month_Bank_Charges',
    text: 'Paid This Month - Bank Charges',
    default: false,
    decimals: 2,
    custom: true
  },
  {
    value: 'Previously_Paid_Expenses',
    text: 'Previously Paid - Expenses',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Attorney_Coverage_Fees',
    text: 'Previously Paid - Attorney Coverage Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Adjusters_Fees',
    text: 'Previously Paid - Adjusters Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Defence_Fees',
    text: 'Previously Paid - Defence Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_TPA_Fees',
    text: 'Previously Paid - TPA Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Previously_Paid_Bank_Charges',
    text: 'Previously Paid - Bank Charges',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Reserve_Expenses',
    text: 'Reserve - Expenses',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Attorney_Coverage_Fees',
    text: 'Reserve - Attorney Coverage Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Adjusters_Fees',
    text: 'Reserve - Adjusters Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_Defence_Fees',
    text: 'Reserve - Defence Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reserve_TPA_Fees',
    text: 'Reserve - TPA Fees',
    default: true,
    decimals: 2
  },
  {
    value: 'Reclosed_Date',
    text: 'Reclosed Date',
    default: false,
    isDate: true,
    custom: true,
  },
  {
    value: 'Net_Recovery',
    text: 'Net Recovery',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Total_Incurred',
    text: 'Total Incurred',
    default: true,
    decimals: 2
  },
  {
    value: 'Reg_No_of_Vehicle_etc',
    text: 'Name Or Reg No Of Aircraft Vehicle, Vessel Etc.',
    default: true
  },
  {
    value: 'Ceded_Reinsurance',
    text: '% Ceded (Reinsurance)',
    default: true
  },
  {
    value: 'Plan',
    text: 'Plan',
    default: true
  },
  {
    value: 'Patient_Name',
    text: 'Patient Name',
    default: true
  },
  {
    value: 'Treatment_Type',
    text: 'Treatment Type',
    default: true
  },
  {
    value: 'Country_of_Treatment',
    text: 'Country Of Treatment',
    default: true
  },
  {
    value: 'Date_of_Treatment',
    text: 'Date Of Treatment',
    default: true,
    isDate: true
  },
  {
    value: 'Expert_Role',
    text: 'Expert Role',
    default: true
  },
  {
    value: 'Expert_Firm',
    text: 'Expert Firm / Company Name',
    default: true
  },
  {
    value: 'Expert_Reference_No',
    text: 'Expert Reference No Etc.',
    default: true
  },
  {
    value: 'Expert_Address',
    text: 'Expert Address',
    default: true
  },
  {
    value: 'Expert_State',
    text: 'Expert State, Province, Territory, Canton Etc.',
    default: true
  },
  {
    value: 'Expert_Postcode_Zip_Code_or_similar',
    text: 'Expert Postcode / Zip Code Or Similar',
    default: true
  },
  {
    value: 'Expert_Country',
    text: 'Expert Country',
    default: true
  },
  {
    value: 'Notes',
    text: 'Notes',
    default: true
  },
  {
    value: 'Date_Claim_Opened',
    text: 'Date Claim Opened',
    default: true,
    isDate: true
  },
  {
    value: 'Date_Coverage_Confirmed',
    text: 'Date Coverage Confirmed',
    default: true,
    isDate: true,
    region: ["US", "Canada", "UK", "EEA"]
  },
  {
    value: 'Date_Claim_Amount_Agreed',
    text: 'Date Claim Amount Agreed',
    default: true,
    isDate: true,
    region: ["US", "Canada", "UK", "EEA"]
  },
  {
    value: 'Date_Claims_Paid',
    text: 'Date Claims Paid (Final)',
    default: true,
    isDate: true,
    region: ["US", "Canada", "UK", "EEA", "South Africa"]
  },
  {
    value: 'Date_Fees_Paid_Final',
    text: 'Date Fees Paid (Final)',
    default: true,
    isDate: true,
    region: ["UK", "EEA", "South Africa"]
  },
  {
    value: 'Date_Reopened',
    text: 'Date Reopened',
    default: true,
    isDate: true,
    region: ["US", "Canada", "UK", "EEA"]
  },
  {
    value: 'Date_of_Subrogation',
    text: 'Date of Subrogation',
    default: true,
    isDate: true,
    region: ["US", "Canada", "UK", "EEA"]
  },
  {
    value: 'Date_Claim_Denied',
    text: 'Date Claim Denied',
    default: true,
    isDate: true,
    region: ["US", "Canada", "UK", "EEA", "Australia"]
  },
  {
    value: 'Reason_for_Denial',
    text: 'Reason For Denial',
    default: true,
    region: ["US", "Canada", "UK", "EEA", "Australia"]
  },
  {
    value: 'Amount_Claimed',
    text: 'Amount Claimed',
    default: true,
    decimals: 2,
    region: ["UK", "EEA"]
  },
  {
    value: 'Date_claim_withdrawn',
    text: 'Date Claim Withdrawn',
    default: true,
    isDate: true,
    region: ["US", "Canada", "UK", "EEA"]
  },
  {
    value: 'Ex_gratia_payment',
    text: 'Ex Gratia Payment',
    default: true,
    decimals: 2
  },
  {
    value: 'Claim_not_paid_as_within_excess',
    text: 'Claim not paid as within excess',
    default: true,
    decimals: 2,
    region: ["UK", "EEA"]
  },
  {
    value: 'Jurisdiction_of_the_claim',
    text: 'Jurisdiction of the claim',
    default: true,
    region: ["Australia"]
  },
  {
    value: 'General_nature_of_loss',
    text: 'General nature of loss',
    default: true,
    region: ["Australia"]
  },
  {
    value: 'Body_functions_or_structures_affected',
    text: 'Body functions or structures affected',
    default: true,
    region: ["Australia"]
  },
  {
    value: 'Severity_of_loss',
    text: 'Severity of loss',
    default: true,
    region: ["Australia"]
  },
  {
    value: 'Litigation_status',
    text: 'Litigation Status',
    default: true
  },
  {
    value: 'Gross_third_party_recoveries_received',
    text: 'Gross third party recoveries received',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Gross_third_party_recoveries_outstanding',
    text: 'Gross third party recoveries outstanding',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Claim_First_Notification_Acknowledgement_Date',
    text: 'Claim First Notification Acknowledgement Date',
    default: true,
    isDate: true
  },
  {
    value: 'Date_First_Reserve_Established',
    text: 'Date First Reserve Established',
    default: true,
    isDate: true
  },
  {
    value: 'Diary_date',
    text: 'Diary date',
    default: true,
    isDate: true
  },
  {
    value: 'Peer_review_date',
    text: 'Peer Review Date',
    default: true,
    isDate: true
  },
  {
    value: 'Year_of_Account',
    text: 'Year of Account',
    default: true,
    disabled: true
  },
  {
    value: 'Paid_this_month_fees_VAT_applied',
    text: 'Paid this month fees – VAT applied',
    default: true,
    decimals: 2,
    region: ["Lloyds Brussels"]
  },
  {
    value: 'Paid_this_month_fees_VAT_Amount',
    text: 'Paid this month fees – VAT Amount',
    default: true,
    decimals: 2,
    region: ["Lloyds Brussels"]
  },
  {
    value: 'Paid_this_month_fees_exempt_Belgian_VAT',
    text: 'Paid this month fees – exempt Belgian VAT',
    default: true,
    decimals: 2,
    region: ["Lloyds Brussels"]
  },
  {
    value: 'Paid_this_month_fees_no_VAT_applied',
    text: 'Paid this month fees – no VAT applied',
    default: true,
    decimals: 2,
    region: ["Lloyds Brussels"]
  },
  {
    value: 'Heads_of_damage_past_economic_loss',
    text: 'Heads of damage – past economic loss',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_future_economic_loss',
    text: 'Heads of damage – future economic loss',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_Past_medical_hospital',
    text: 'Heads of damage - Past medical, hospital',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_Future_medical_hospital',
    text: 'Heads of damage - Future medical, hospital',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_Future_caring_services',
    text: 'Heads of damage - Future caring services',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_General_damages',
    text: 'Heads of damage - General damages',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_Interest',
    text: 'Heads of damage – Interest',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_Plaintiff_legal_costs',
    text: 'Heads of damage - Plaintiff legal costs',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_Defendant_legal_costs',
    text: 'Heads of damage - Defendant legal costs',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_Investigation_costs',
    text: 'Heads of damage - Investigation costs',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Heads_of_damage_other',
    text: 'Heads of damage – other',
    default: true,
    decimals: 2,
    region: ["Australia"]
  },
  {
    value: 'Lead_syndicate_number',
    text: 'Lead syndicate number',
    default: true,
    region: ["Hong Kong"]
  },
  {
    value: 'Hong_Kong_Insured_Occupation_Code',
    text: 'Hong Kong Insured Occupation Code',
    default: true,
    region: ["Hong Kong"]
  },
  {
    value: 'IA_Accounting_Class',
    text: 'IA Accounting Class',
    default: true,
    region: ["Hong Kong"]
  },
  {
    value: 'IA_Sub_accounting_class',
    text: 'IA Sub-accounting class',
    default: true,
    region: ["Hong Kong"]
  },
  {
    value: 'Nature_of_claim',
    text: 'Nature of claim',
    default: true,
    region: ["Hong Kong"]
  },
  {
    value: 'Type_of_vehicle_code',
    text: 'Type of vehicle – code',
    default: true,
    region: ["Hong Kong"]
  },
  {
    value: 'Number_of_vessels',
    text: 'Number of vessels',
    default: true,
    region: ["Hong Kong"]
  },
  {
    value: 'Management_expense',
    text: 'Management expense',
    default: true,
    region: ["Hong Kong"]
  },
  {
    value: 'Lloyds_Platform',
    text: 'Lloyd\'s Platform',
    default: true,
    region: ["Lloyds Brussels"]
  },
  {
    value: 'Subrogation_Recovered_This_Month',
    text: 'Subrogation Recovered This Month',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Subrogation_Previously_Recovered',
    text: 'Subrogation Previously Recovered',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Total_Subrogation_Recovered',
    text: 'Total Subrogation Recovered',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Salvage_Recovered_This_Month',
    text: 'Salvage Recovered This Month',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Salvage_Previously_Recovered',
    text: 'Salvage Previously Recovered',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Total_Salvage_Recovered',
    text: 'Total Salvage Recovered',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Deductible_Recovered_This_Month',
    text: 'Deductible Recovered This Month',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Deductible_Previously_Recovered',
    text: 'Deductible Previously Recovered',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Total_Deductible_Recovered',
    text: 'Total Deductible Recovered',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Gross_Recovery_Received_This_Month',
    text: 'Gross Recovery Received This Month',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Gross_Recovery_Previously_Received',
    text: 'Gross Recovery Previously Received',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Gross_Recovery_Total',
    text: 'Gross Recovery Total',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Recovery_Fees_Paid_This_Month',
    text: 'Recovery Fees Paid This Month',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Recovery_Fees_Paid_Previously_Paid',
    text: 'Recovery Fees Paid Previously Paid',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Recovery_Fees_Total',
    text: 'Recovery Fees Total',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Driver_Age',
    text: 'Driver Age',
    default: false,
    custom: true,
  },
  {
    value: 'Cargo_Hauled',
    text: 'Cargo Hauled',
    default: false,
    custom: true,
  },
  {
    value: 'Reefer_Claim',
    text: 'Reefer Claim',
    default: false,
    custom: true,
  },
  {
    value: 'Reefer_Age',
    text: 'Reefer Age',
    default: false,
    custom: true,
  },
  {
    value: 'Cargo_Total_Insured_Value',
    text: 'Cargo Total Insured Value',
    default: false,
    custom: true,
  },
  {
    value: 'Vehicle_Unit_Age',
    text: 'Vehicle Unit Age',
    default: false,
    custom: true,
  },
  {
    value: 'Vehicles_Total_Insured_Value',
    text: 'Vehicles Total Insured Value',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Towing_Storage_Fees',
    text: 'Towing Storage Fees',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Trailer_Interchange',
    text: 'Trailer Interchange',
    default: false,
    custom: true,
  },
  {
    value: 'Non_Owned_Trailer',
    text: 'Non Owned Trailer',
    default: false,
    custom: true,
  },
  {
    value: 'MTC_Peril',
    text: 'MTC Peril',
    default: false,
    custom: true,
  },
  {
    value: 'Fault',
    text: 'Fault',
    default: false,
    custom: true,
  },
  {
    value: 'Distance',
    text: 'Distance',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'RIP_Paid_This_Month',
    text: 'RIP Paid This Month',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'RIP_Brokerage_Paid_This_Month',
    text: 'RIP Brokerage Paid This Month',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'RIP_Paid_to_Date',
    text: 'RIP Paid to Date',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'RIP_Brokerage_Paid_to_Date',
    text: 'RIP Brokerage Paid to Date (5%)',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Incurred_RIP_to_Underwriter',
    text: 'Incurred RIP to Underwriter',
    default: false,
    decimals: 2,
    custom: true,
  },
  {
    value: 'Cause_and_Origin_Appointed',
    text: 'Cause & Origin Appointed',
    default: false,
    custom: true
  },
  {
    value: 'Third_Party_Involvement',
    text: 'Third Party Involvement',
    default: false,
    custom: true
  },
  {
    value: 'Public_Adjuster',
    text: 'Public Adjuster',
    default: false,
    custom: true
  },
  {
    value: 'Other_Disbursements',
    text: 'Other Disbursements',
    default: false,
    decimals: 2,
    custom: true
  },
  {
    value: 'Initial_Reserve_Value',
    text: 'Initial Reserve Value',
    default: false,
    decimals: 2,
    custom: true
  },
  {
    value: 'Date_of_Last_Correspondence_Sent',
    text: 'Date of Last Correspondence Sent',
    default: false,
    isDate: true,
    custom: true
  },
  {
    value: 'Date_of_Last_Correspondence_Received',
    text: 'Date of Last Correspondence Received',
    default: false,
    isDate: true,
    custom: true
  },
  {
    value: 'Claims_Examiner',
    text: 'Claims Examiner',
    default: false,
    custom: true
  },
  {
    value: 'Premises_Number',
    text: 'Premises Number',
    default: false,
    custom: true
  },
  {
    value: 'Building_Number',
    text: 'Building Number',
    default: false,
    custom: true
  },
  {
    value: 'Class_Code',
    text: 'Class Code',
    default: false,
    custom: true
  },
  {
    value: 'NAIC_Code',
    text: 'NAIC Code',
    default: false,
    custom: true
  },
  {
    value: 'Broker',
    text: 'Broker',
    default: false,
    custom: true
  },
  {
    value: 'FCP',
    text: 'FCP',
    default: false,
    custom: true
  },
  {
    value: 'BDX_Key',
    text: 'LimeIQ BDX Key',
    width: 170,
    default: true,
    disabled: true,
    hidden: true
  }
]